
import {PacsEntry} from './pacsentry.model';
export class UploadFileEntry{
	constructor(
        public filename?:string,
        public fileinfo?:PacsEntry,
        ){}
	
}